var _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShotlistThumb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 142,
    viewBox: "0 0 209 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_1._Opening_Shot_:_A_close-up_of_a_ring_light_turning_on_with_a_soft_glow_emanating_from_the_center._2._Mastering_the_Ring_Light_:_Clips_of_individuals_adjusting_the_position_and_height_of_the_ring_light_in_various_settings_demonstrating_its_versat",
    "data-name": "1. **Opening Shot**: A close-up of a ring light turning on, with a soft glow emanating from the center. 2. **Mastering the Ring Light**: Clips of individuals adjusting the position and height of the ring light in various settings, demonstrating its versat",
    fill: "#08231b",
    fontSize: 2.65,
    fontFamily: "Rubik-Regular, Rubik",
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2
  }, "1. **Opening Shot**: A close-up of a ring light turning on, with a soft glow emanating from the center."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8
  }, "2. **Mastering the Ring Light**: Clips of individuals adjusting the position and height of the ring light in various settings, demonstrating its versatility."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "3. **Consistent Illumination**: A split-screen shot showing a person\u2019s face with and without the ring light, highlighting the even illumination it provides."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "4. **Shadows Control**: Close-up of a hand turning up the brightness knob on the ring light to eliminate harsh shadows."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "5. **Skin Tone Control**: A clip showing the brightness being turned down on the ring light to prevent overexposure of the subject\u2019s skin."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "6. **Subject Illumination**: Cinematic shot of a person being beautifully lit by the ring light, emphasizing the flattering illumination."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "7. **Color Temperature Adjustment**: Close-up of a hand adjusting the color temperature dial on the ring light to shift from warm to cool tones."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 41
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 44
  }, "8. **Atmosphere Customization**: Montage of shots demonstrating the ring light\u2019s effect on the atmosphere, with warm and cool lighting settings."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 47
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 50
  }, "9. **Ring Light Portability**: Clips of the ring light being set up in different filming locations, indoors and outdoors, showcasing its adaptability."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 56
  }, "10. **Ring Light Reflection**: Creative shot capturing the ring light\u2019s reflection in a mirror, glass surface, or subject\u2019s eyes."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 59
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 62
  }, "11. **User-Friendly Design**: Close-up of the ring light\u2019s user interface, showcasing its intuitive controls and seamless integration."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 65
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 68
  }, "12. **Corporate Testimonials**: Shots of a well-lit corporate setting, showcasing the ring light\u2019s contribution to crafting compelling testimonials."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotlistThumb);
export default __webpack_public_path__ + "static/media/shotlistThumb.9afed18bb488ed89f33ceeeb19c3e090.svg";
export { ForwardRef as ReactComponent };